import { defineComponent as _defineComponent } from 'vue'
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';
import TagDisplay from '@/components/tagging/TagDisplay.vue';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import { Project } from '@/views/project-forum/models/ProjectForum';
import {
  computed, PropType, toRefs
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSidebarProjectSummary',
  props: {
  project: {
    type: Object as PropType<Project | null>,
    default: null
  },
},
  setup(__props) {

const props = __props;



const { project } = toRefs(props);
const { getFormattedDate } = useFormattedDateTime();

const startDate = computed(() => (project.value?.startDate ? getFormattedDate(project.value?.startDate) : null));

const isRemoteWorkRedundant = computed(() => {
  switch (project.value?.remoteWork) {
    case 'ZERO_DAYS_PER_WEEK':
    case 'FIVE_DAYS_PER_WEEK':
    case 'ONSITE_ONLY':
    case 'REMOTE_ONLY':
      return true;
  }
  return false;
});

return { __sfc: true,props, project, getFormattedDate, startDate, isRemoteWorkRedundant, BCXAvatar, BCXItemsWithPoints, TagDisplay }
}

})